export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  padding: '2',
  fontSize: '3',
  showOriginDestinationImage: false,
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: true,
  fareItemJourneyType: {},
  showTravelClass: true,
  fareItemTravelClass: {},
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: false,
    showDestination: false,
    showSeparator: false,
    showOriginLabel: true,
    fontSize: '3',
    marginBottom: 'auto',
    textTransform: 'uppercase',
    style: {
      lineHeight: '1',
    },
    originLabelStyles: {
      fontWeight: 'bold',
      paddingRight: '1',
    },
    originAirportCodeStyles: {
      fontWeight: 'bold',
    },
  },
  showRoute: false,
  fareItemRoute: {
    fontWeight: 'bold',
    fontSize: '4',
    marginBottom: '2',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    showDepartureText: false,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareBodyItem: {
    grow: '1',
    textColor: 'dark',
  },
  fareFooterItem: {
    justifyContent: 'end',
    alignItems: 'center',
    textColor: 'dark',
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingBottom: '2',
    paddingTop: '1',
    pricePromoStyles: {
      fontWeight: 'bold',
      fontSize: '3',
    },
    currencyStyles: {
      fontSize: '5',
      textColor: 'black',
      style: {
        lineHeight: '1',
      },
    },
  },
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    showCallToActionTextMin: true,
    paddingHeight: '1',
    style: {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
  },
  showCallToAction: true,
  showLastSeen: false,
};
